import { useMemo } from 'react';
import { useLeasingTenantWebApiHandler_getTenantInfo } from '@zg-rentals/ts-leasing-client-react-query';
import { Person } from '../models';

export const useTenant = () => {
  const { data: tenantData, isLoading, error } = useLeasingTenantWebApiHandler_getTenantInfo();

  const tenant = useMemo(() => (tenantData ? new Person(tenantData) : null), [tenantData]);

  return { tenant, isLoading, error };
};
